module.exports = __webpack_public_path__ + "static/img/200056.84c05499.png";